























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class RadioOff extends Vue {
    @Prop({default: "#010101"}) private radioOffColor! : string;
}
